import { all, takeLatest, debounce } from 'redux-saga/effects';

import { Types as ActionTypes } from './actions';
import sagas from './sagas';

import { DEBOUNCE_MS } from '../constants/config';

function* rootSaga() {
    yield all([
        takeLatest(ActionTypes.CHANGE_PAYMENT_OPTIONS, sagas.changePaymentOptions),
        debounce(DEBOUNCE_MS, ActionTypes.CHANGE_CASH_DOWN_AMOUNT, sagas.changeCashDownAmount),
        debounce(DEBOUNCE_MS, ActionTypes.CHANGE_LIEN_AMOUNT, sagas.changeLienAmount),
        debounce(DEBOUNCE_MS, ActionTypes.CHANGE_TRADE_IN_AMOUNT, sagas.changeTradeInAmount),
        debounce(DEBOUNCE_MS, ActionTypes.CHANGE_PAYMENT_FREQUENCY, sagas.changePaymentFrequency),
        takeLatest(ActionTypes.CHANGE_DESIRED_PAYMENT, sagas.changeDesiredPayment),
        takeLatest(ActionTypes.CHANGE_PLAN, sagas.changePlan),
        takeLatest(ActionTypes.INITIALIZE_STORE, sagas.initializeStore),
        takeLatest(ActionTypes.REFRESH_QUOTE, sagas.refreshQuote),
        takeLatest(ActionTypes.SELECT_CASH_PLAN, sagas.selectCashPlan),
        takeLatest(ActionTypes.SELECT_PAYMENT, sagas.selectPayment),
        takeLatest(ActionTypes.SELECT_PLAN, sagas.selectPlan),
        takeLatest(ActionTypes.UPDATE_PROFIT_ROLL, sagas.updateProfitRoll),
        takeLatest(ActionTypes.UPDATE_QUOTE_INFORMATION, sagas.updateQuoteInformation),
    ]);
}

export default rootSaga;
